module.exports = __webpack_public_path__ + "img/thumbnail_MuteSwan_m_normal.04549ca2.png";